var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElipsesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 19,
    viewBox: "0 0 6 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00013 5.16671C4.19719 5.16671 5.16676 4.19712 5.16676 3.00004C5.16676 1.80296 4.19719 0.833374 3.00013 0.833374C1.80306 0.833374 0.833496 1.80296 0.833496 3.00004C0.833496 4.19712 1.80306 5.16671 3.00013 5.16671ZM3.00013 7.33337C1.80306 7.33337 0.833496 8.30296 0.833496 9.50004C0.833496 10.6971 1.80306 11.6667 3.00013 11.6667C4.19719 11.6667 5.16676 10.6971 5.16676 9.50004C5.16676 8.30296 4.19719 7.33337 3.00013 7.33337ZM3.00013 13.8334C1.80306 13.8334 0.833496 14.803 0.833496 16C0.833496 17.1971 1.80306 18.1667 3.00013 18.1667C4.19719 18.1667 5.16676 17.1971 5.16676 16C5.16676 14.803 4.19719 13.8334 3.00013 13.8334Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElipsesIcon);
export default __webpack_public_path__ + "static/media/elipses-icon.539f81d8881217cb2ade2f75c4e6d850.svg";
export { ForwardRef as ReactComponent };